import { render, staticRenderFns } from "./bargain.vue?vue&type=template&id=7f64fe7b&scoped=true&"
import script from "./bargain.vue?vue&type=script&lang=js&"
export * from "./bargain.vue?vue&type=script&lang=js&"
import style0 from "./bargain.vue?vue&type=style&index=0&id=7f64fe7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f64fe7b",
  null
  
)

export default component.exports